import Image from "next/image";
import { memo } from "react";
import Equalizer from "./equalizer";
import { useAppSelector } from "redux-share/hooks";
import { conditions } from "helpers";
import { ConditionName } from "interfaces";
import IMAGES from "../../../../../images/importImages";
import { shallowEqual } from 'react-redux'

const JustAudio = () => {

    const { details } = useAppSelector(({ videoData: { details } }) => ({ details }), shallowEqual);

    return (
        <div id="just-audio" className="pl-w-full pl-h-full pl-absolute pl-top-0 pl-right-0" style={{ background: `linear-gradient(39deg, rgba(16, 9, 49, 1) 0%, rgba(75, 14, 87, 1) 100%)` }}>
            <div className={`w-full h-full px-5`}>
                <div className={`pl-w-full pl-flex pl-gap-4 pl-absolute pl-top-[70px]`}>
                    <Image src={conditions(ConditionName.hasBanner) ? details.banner : IMAGES.justAudioCover} width={72} height={72} className="pl-rounded-[8px]" />
                    <div className="pl-text-white pl-flex pl-flex-col pl-gap-[9px]">
                        <p className={`pl-mt-1 pl-text-[18px] pl-font-bold`}>{details.title}</p>
                        <p className="pl-font-normal pl-text-[16px]">{details.description}</p>
                    </div>
                </div>
            </div>
            <Equalizer />
        </div>
    )
}

export default memo(JustAudio);